import { ShipmentContact } from "../types/domain";

const formatContact = (contact: ShipmentContact): string => {
  const name = [contact.firstName, contact.lastName].filter(Boolean).join(" ");

  return [name, contact.email, contact.phoneNumber].filter(Boolean).join(", ");
};

export default formatContact;
